export default "__VITE_ASSET__BmHj7F6o__"